<template>
  <div>
    <div class="order-info">
      <div class="info-item">申请用途: {{ $dict.nameOf('order_car_finance_used', orderFinance.used) }}</div>
      <div class="info-item">意向金额: {{ orderFinance.intentionMoney }}</div>
      <div class="info-item">申请金额: {{ orderFinance.applyMoney }}</div>
      <div class="info-item">审批金额: {{ orderFinance.approveMoney }}</div>
      <div class="info-item">融资成数: {{ orderFinance.approveProportion }}</div>
      <div class="info-item">融资平台: {{ orderFinance.platformName }}</div>
      <!--      <div class="info-item">产品: {{ orderFinance.productId }}</div>-->
      <div class="info-item">名称: {{ orderFinance.productName }}</div>
      <div class="info-item">利率: {{ orderFinance.productRates }}</div>
      <div class="info-item">一次性服务费: {{ orderFinance.onceServeFee }}</div>
      <div class="info-item">产品罚息: {{ orderFinance.interestPenalty }}</div>
      <div class="info-item">期数: {{ orderFinance.duration }}</div>
      <div class="info-item">认收资料类型: {{ orderFinance.type }}</div>
      <div class="info-item">申请备注: {{ orderFinance.notes }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderFinance",
  props: {
    orderFinance: {
      type: Object,
      required: true
    }
  },
  computed: {}
}
</script>

<style scoped>
.order-info {
  display: flex;
  flex-wrap: wrap;
}

.info-item {
  flex-basis: calc(33.333% - 20px);
  box-sizing: border-box;
  min-width: 200px;
  margin: 10px;
}
</style>
